import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from "react-router";
import { AppRouter } from './routing/routes';
import { AuthServiceProvider } from './shared/authservice';
import { EchoProvider } from './shared/echo';
import { ProviderAuth } from './api/auth';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <AuthServiceProvider>
      <EchoProvider>
        <ProviderAuth>
          <AppRouter />
        </ProviderAuth>
      </EchoProvider>
    </AuthServiceProvider>
  </BrowserRouter>
);
